import terms20261101 from './2026-11-01';

// Billing B1.5. Every version a host ever agreed to stays here, so we can show
// the exact words. Add a version: new file, add it below, point CURRENT at it.
export const SUNDAY_TERMS = {
  [terms20261101.version]: terms20261101
};

export const CURRENT_SUNDAY_TERMS = terms20261101;
